// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2135":"4dec4f121fdaa928","8122":"c6727290fc4d8c89"}[chunkId] + ".js";
};